module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0131.jpg?v=3267376b";